import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const adminApi = (token) =>
  axios.create({
    baseURL: API,
    headers: { Authorization: `Bearer ${token}` },
  });

export function getAdminToken() {
  return localStorage.getItem("hfh_admin_token") || "";
}

export function setAdminToken(token) {
  if (token) localStorage.setItem("hfh_admin_token", token);
  else localStorage.removeItem("hfh_admin_token");
}
